<template>
  <div class="tarjeta">
    <div class="container-titulo-informe">
      <span>{{ reportType }}</span>
    </div>
    <div class="container-autor">
      <span>Autor: <b>{{ autor }}</b></span>
      <br/>
      <span>Fecha de creación: <b>{{ fecha }} {{ hora }}</b></span>
    </div>
    <div @click="goDetail" v-if="this.$store.state.permissions.canViewInformesAuditorias" class="tarjeta-selection">
        <v-icon color="black">mdi-chevron-right</v-icon>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      fecha: null,
      hora: null
    }
  },
  props: {
    autor: null,
    createdAt: null,
    clubId: null,
    partido: null,
    partidoId: null,
    departamento: null,
    estado: null,
    detailId: null,
    reportType: null,
    cardType: null,
    modified: null,
    titulo: null
  },
  methods: {
    goDetail () {
      this.$router.push({ name: 'informe-auditoria', params: { id: this.detailId } })
    },
    formatDateTime () {
      let dateTime = this.createdAt.split('T')
      this.fecha = dateTime[0]
      const [dia, mes, anio] = this.fecha.split('-')
      this.fecha = `${anio}-${mes}-${dia}`
      this.hora = dateTime[1].split('.')[0]
    }
  },
  created () {
    this.formatDateTime()
  }
}
</script>

<style scoped>
.tarjeta{
  background-color: #eeeeee;
  width: 90%;
  height: 60px;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  overflow: hidden;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.25);
  margin: 20px auto;
}

span{
  font-size: 1.2em;
  color: #293968;
}

.container-titulo-informe, .container-autor{
  justify-items: center;
}

.container-autor{
  margin-right: 20px;
}

.container-titulo-informe{
  margin-left: 20px;
}

.tarjeta-selection{
  margin-right: 20px;
  cursor: pointer;
}

</style>
